(function () {
  var bar = document.querySelector('[data-lb-sticky-bar]');
  if (!bar) return;

  var trigger = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!trigger || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting;
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  observer.observe(trigger);
})();
